import { useGetPaymentTermsIncludeDelete, useToggleStatusMutation } from "@/services";
import { MasterModuleLayout, useMasterModule } from "../Common";
import usePaymentTerms from "./usePaymentTerm";

const PaymentTerm = () => {
  const { columns } = usePaymentTerms();
  
  const masterHook = useMasterModule({
    queryKey: "payment-terms",
    idKey: "paymentTermId",
    nameKey: "paymentTermName",
    useGetDataQuery: useGetPaymentTermsIncludeDelete,
    useToggleStatusMutation: useToggleStatusMutation,
    module: "payment-terms",
    statusSuccessMessage: "Payment Term Status Updated Successfully",
  });

  return <MasterModuleLayout title="Payment Term" hookResult={masterHook} extraColumns={columns} />;
};

export default PaymentTerm;
